import { isFinanceProject } from 'config';
import { useTranslation } from 'libs/i18n';
import { CompanyStateRegistration } from 'modules/onboarding/legal/components';

import { useCompanyStateRegistration } from '../hooks';
import { useOnboardingContext } from '../hooks/useOnboardingContext';
import { PageComponentProps } from '../types';

export const CompanyStateRegistrationStep = ({
  canGoBack,
}: PageComponentProps) => {
  const {
    files,
    initialValues,
    submitDisabled,
    submitLoading,
    goToBack,
    onAddFiles,
    onRemoveFile,
    onSubmit,
  } = useCompanyStateRegistration();

  const { t } = useTranslation();

  const { step } = useOnboardingContext();

  return (
    <CompanyStateRegistration
      canGoBack={canGoBack}
      enabledFiles={isFinanceProject()}
      files={files}
      initialValues={initialValues}
      step={step}
      submitDisabled={submitDisabled}
      submitLoading={submitLoading}
      subTitle={t(
        'onboarding.legalClientLegalHead.companyStateRegistration.subtitle'
      )}
      onAddFiles={onAddFiles}
      onGoBack={goToBack}
      onRemoveFile={onRemoveFile}
      onSubmit={onSubmit}
    />
  );
};
